export default {
  pageTitle: 'TD(限时折扣)报名',
  region: '国别',
  applicationType: '申请类型',
  applyProduct: '申请商品',
  check: '检索',
  MRP: '市场指导价',
  b: 'b',
  salePrice: '售价',
  productRating: '商品评分', // 此处几项原文本就是写死的
  Sold: '已售出',
  store: '店铺',
  shippingPlace: '仓库和发货地',
  batchSettings: '批量设置',
  placeholder1: '闪购价',
  dealPrice: '促销价',
  timeLimit: '有效期',
  time1: '1天',
  time2: '2天',
  time3: '3天',
  time4: '5天',
  time5: '7天',
  time6: '15天',
  time7: '30天',
  success: '报名成功',
  faild: '以下SKU报名失败',
  registrationId: '报名ID',
  msg: 'Msg',
  // ----------------
  listingTableTitle1: 'SKU#',
  listingTableTitle2: '标题/规格',
  listingTableTitle3: '市场指导价',
  listingTableTitle4: '售价',
  listingTableTitle5: '库存',
  listingTableTitle6: '促销价',
  // ----------
  submitButtonVal1: '提交',
  placehOlderSession1: '请选择',
  placehOlderSession2: '加载中...',
  SUBM1: '提交',
  SUBM2: '更新',
  // -------------------
  storeIdMap1: 'TopSelective',
  storeIdMap2: 'FlyingGoods',
  storeIdMap3: 'Cost-effective',
  storeIdMap4: 'FashionMall',
  storeIdMap5: 'Digitone',
  storeIdMap6: 'FlashSK',
  // ----------------
  warning1: 'SKU或Listing id应为数字',
  warning2: 'SKU ID不存在',
  warning3: '此SKU已下架',
  warning4: '此Listing已下架',
  warning5: '此信息不完整',
  warning6: '承诺库存应为数字',
  warning7: '承诺库存不能超出商品现有库存',
  warning8: '请输入大于0的值',
  warning9: '活动价应为数值',
  warning10: '活动价应低于普通售价',
  warning11: '促销价不能大于普通售价',
  warning12: '促销价应该大于0',
  warning13: '请检查Listing数据',
  error1: 'sku#未填写',
  error2: '促销价未填写',
  error3: '至少要勾选一个SKU',
  error4: '促销价不能大于普通售价',
  error5: '促销价应该大于0'
}
